import React, { useEffect } from 'react';
import { dbDateToTimestamp, parseEntities, toLongDateDisplay, parseDateDesktopShort } from '../../utils/helpers';
import Tag from './Tag';
import AgendaIcon from '../svg/AgendaIcon';
import DateArrow from '../svg/DateArrow';
import { showTicketButtons } from '../../../../vriendenverkoop/vriendenverkoop';

const CourseCard = ({ element }) => {
	const startDate = parseDateDesktopShort(dbDateToTimestamp(element.times[0].program_start));
	const endDate = parseDateDesktopShort(dbDateToTimestamp(element.times[0].program_end));
	const isMulitDay = startDate !== endDate;

	useEffect(() => {
		let key = '/vriendenvancultura25-26';
		if (window.location.toString().indexOf(key) > 0) {
			showTicketButtons();
		}
	}, []);


   return (
      <article className="course-overview__item">
      <a className="course-overview__item-link" href={element.permalink}>

            <figure className="course-overview__item-img">

				{element.poster_mobile || element.poster_desktop ? (
				<img
				   loading="lazy"
					src={element.poster_mobile ? element.poster_mobile : element.poster_desktop}
					alt=""
					className="agenda-card__img"
				/>
				) : null}

               <div className="course-overview__item-img-tags">
						{element.tags?.genre &&
							Object.keys(element.tags.genre).map((genre, index) => <Tag key={index} tagText={element.tags.genre[genre]} displayIcon={false} classname="course-overview__item-img-tag" />)}
               </div>

            </figure>

         <div className="course-overview__item-content">
            <h2 className="h3">{parseEntities(element.title)}</h2>
            {element.subtitle ? <p>{element.subtitle}</p> : null}
         </div>
      </a>
      </article>
   );
};

export default CourseCard;



